module.exports = __webpack_public_path__ + "static/media/productos-tab.e0ac134f.png";